import styled from "styled-components";
import { Colors, TextFont } from "../../config";

const TableHeader = ({
  columns,
  columnFontColor = Colors.coolGrey,
  columnFontSize = "1.125rem",
  columnFontWeight = 400,
}) => {
  return (
    <StyledTableHead>
      <tr>
        {columns?.map((column) => (
          <th align="left" key={column.path || column.key}>
            <TextFont
              fontColor={columnFontColor}
              fontSize={columnFontSize}
              fontWeight={columnFontWeight}
            >
              {column.label}
            </TextFont>
          </th>
        ))}
      </tr>
    </StyledTableHead>
  );
};

const StyledTableHead = styled.thead`
  > tr > th {
    padding: 0;
  }
  > tr > th > div {
    padding: 1rem;
    padding-left: 0rem;
  }
`;

export default TableHeader;
